const TITLE = '¿Qué es Patio Púrpura?';

const DESCRIPTION = "Emprendimiento de una tica amante del pan y del buen café. " + 
"Pan artesanal hecho en casa con paciencia y amor. " +  
"Porque todo lo bueno toma su tiempo.";

const EMAIL = "patiopurpura@gmail.com";



const DESCRIPTION_CONTACT = "Puedes contactárnos por medio del correo electrónico: patiopurpura@gmail.com o búscanos en Instagram como @patiopurpura";

const WHAT_IS_SOURDOUGH_TITLE = "¿Qué es la masa madre?";

const BENEFITS_TITLE = "Beneficios";

const SOURDOUGH = [
  {
    id: 0,
    title: "Es un fermento natural",
    description: "Debido a los microorganismos que crean el fermento, los cuales funcionan como probióticos intestinales."
  },
  {
    id: 1,
    title: "Una forma de leudar el pan (sin levaduras agregadas)",
    description: "",
  },
];

const PANES_TITLE = "Nuestros Panes";

const PANES = [
  {
    id: 0,
    name: "Básico",
    ingredients: "Harina blanca, harina integral, sal y masa madre.",
    description: "",
    price: "4.000 colones"
  },
  {
    id: 1,
    name: "Básico con Semillas",
    ingredients: "Linaza, girasol, calabaza, semillas de ajonjolí negro y blanco.",
    description: "",
    price: "4.300 colones"
  },
  {
    id: 2,
    name: "Básico con Aceitunas Negras",
    ingredients: "Básico con aceitunas negras.",
    description: "",
    price: "4.500 colones"
  },
  {
    id: 3,
    name: "De Arándanos y Nueces",
    ingredients: "Arándanos y nueces.",
    description: "",
    price: "4.700 colones"
  },
  {
    id: 4,
    name: "De Tomate Deshidratado, Queso Mozarella y Romero",
    ingredients: "Tomate deshidratado, queso mozzarella, romero y una pizca de cúrcuma.",
    description: "",
    price: "4.800 colones"
  },
  {
    id: 5,
    name: "Pan de Cacao y Arándanos",
    ingredients: "Harina, harina integral, sal, cacao en polvo, arándanos.",
    description: "El cacao aporta aroma y color, sin convertirlo en un pan dulce, ya que no lleva azúcar.",
    price: "4.500 colones"
  }
];

const BENEFITS = [
  {
    id: 0,
    title: "Mejoran la salud intestinal y la absorción de nutrientes",
    description: "Debido a los microorganismos que crean el fermento, los cuales funcionan como probióticos intestinales."
  },
  {
    id: 1,
    title: "Control del índice glucémico",
    description: "Algunas baterias durante su actividad ingieren ciertos carbohidratos de la harina",
  },
  {
    id: 2,
    title: "Contiene ácidos orgánicos que contribuyen a conservar sus valores nutricionales",
    description: "",
  },
];

const textService = {

  getMainTitle: () => {
    return TITLE;
  },

  getWhatIsSourdoughTitle() {
    return WHAT_IS_SOURDOUGH_TITLE;
  },

  getBenefitsTitle() {
    return BENEFITS_TITLE;
  },

  getMainDescription: () => {
    return DESCRIPTION;
  },

  getContactDescription: () => {
    return DESCRIPTION_CONTACT;
  },

  getSourdoughExplanation: () => {
    return SOURDOUGH;
  },

  getSourdoughBenefits: () => {
    return BENEFITS;
  },

  getEmail: () => {
    return EMAIL;
  },

  

  getPanesTitle: () => {
    return PANES_TITLE;
  },

  getPanes: () => {
    return PANES;
  },

};

export default textService;